import { useEffect, useState } from "react";
import Navbar from "./components/Navbar/Navbar";
import Header from "./components/Header/Header";
import AboutMe from "./components/AboutMe/AboutMe";
import Skills from "./components/Skills/Skills";
import Portfolio from "./components/Portfolio/Portfolio";
import Contact from "./components/Contact/Contact";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

function App() {
   const [message, setMessage] = useState(false);

   useEffect(() => {
      if (localStorage.getItem("message") === "true") {
         setMessage(true);
         setTimeout(() => {
            setMessage(false);
            localStorage.setItem("message", "false");
         }, 3000);
      }
   }, []);

   return (
      <div style={{ position: "relative" }}>
         {message && (
            <>
               <div className="messageSend" role="alert">
                  MESSAGE SENT SUCCESSFULLY
               </div>
            </>
         )}
         <Navbar />
         <Header />
         <AboutMe />
         <hr />
         <div id="skills" className="text-center mt-5 display-4 fw-bold">
            Skills and Tools
         </div>
         <Skills />
         <hr />
         <div
            id="portfolio"
            style={{ scrollMarginTop: "90px" }}
            className="text-center mt-5 display-4 fw-bold"
         >
            Portfolio
         </div>
         <Portfolio />
         <hr />
         <div id="contact" style={{ scrollMarginTop: "90px" }} className="text-center mt-5 display-4 fw-bold">
            Contact
         </div>
         <Contact />
         <br />
         <br />
         <br />
         <br />
         <br />
      </div>
   );
}

export default App;
